<template>
    <div class="image-wrapper" v-bind:style="height">
        <span><a href="">{{imgTitle}}</a></span>
        <img :src="imgURL" width="100%" />
    </div>
</template>


<script>
    export default {
        name: "headimage",
        props: {
            aspectratio: {
                default: 3.2,
                type: Number
            },
            imgTitle: {
                default: "",
                type: String
            },
            imgURL: {
                default: "",
                type: String
            }
        },
        data: function() {
            return {
                height: {
                }
            };
        },
        computed: {
            wrapperHeight: function () {
                let cropHeight = 100 / this.aspectratio / 2;
                return {
                    paddingTop: cropHeight + '%',
                    paddingBottom: cropHeight + '%',
                };

            }
        },
        mounted() {
            this.height = this.wrapperHeight;
        },
    };
</script>
